import React from 'react';
import {Card, Col, Layout, Row} from "antd";

// import 'antd/lib/card/style/css';


// import 'antd/lib/layout/style/css';


// import 'antd/lib/row/style/css';


// import 'antd/lib/col/style/css';


import './PublicLayout.css';
import { getCustomLogos } from '../../Helpers/utils';

const PublicLayout = (props) => {
  const base64LogoDark = getCustomLogos().base64LogoDark;
  const renderImg = () => {
    return (
      <img style={{width:'300px', maxWidth:'100%', height:'auto'}} alt={''} src={base64LogoDark}/>
    );
  };
  
  return (
    <Layout className="h-100 public-layout">
      <Layout.Content>
        <Row type="flex" justify="space-around" align="middle" className={'h-100'}>
          <Col className={props.size === 'large' ? 'public-form-column public-form-large' : 'public-form-column'}>
            <Card bodyStyle={props.bodyStyle?props.bodyStyle:{}} className={'public-card'} title={props.title === 'logo' ? renderImg() : props.title}
                  headStyle={{textAlign: 'center'}}>
              {props.children}
            </Card>
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  );
};

export default PublicLayout;
